import * as React from 'react';

import { IConfig } from './types/Config.Type';
import { ILoaderProps } from './map/layer/ILoaderProps';

import { Mangroves } from './map/layers/mpcap/polygons/Mangroves';
import { Ponds } from './map/layers/mpcap/polygons/Ponds';

const MANGROVES = {
  2019: "e49a184c21d6e8b026932f9e53195983eec33015",
  2020: "8a5b293918565951b9acaf84a220ca4f4da4fe10",
  2021: "4fdedb56f0b085022b06ee07b3930cc2fca2caeb",
  2022: "748cac5ab1b29929493bad8e61a123b051faa756",
  2023: "3c0466ef39a01505638b2200fc8019440b7055fc",
  2024: "0497a041f07226e6b7ba2ef4b1db3fadb2625024"
}

const PONDS = {
  2019: "2a6e5e5b93ba04e271ef3ae68438554988ee5f45",
  2020: "a180538d7c38de9599907c50a79a9bb96e225334",
  2021: "647e6ecbb5da87afb930e87e8c56a88875061060",
  2022: "896561fad3f9fd5c95c905a8239ff2187cc36835",
  2023: "067a7a02daa9135f2813a49bad4e6d7a79208275",
  2024: "fb87ea24777d77fe247abe6228c4b1e86d17256e"
}

const Config: IConfig = {
  map: {
    mapKey: "pk.eyJ1IjoibG9uZ2xpbmVlbnZpcm9ubWVudCIsImEiOiJjbGF0cHF1ZWUwM2l0M3FwcDcyN3B1YXpmIn0.snFi9yTPEZ5lfQxE3h3Epg",
    greyStyle: "mapbox://styles/longlineenvironment/clatpsjsl003r15okdwsdclmi",
    satelliteStyle: "mapbox://styles/longlineenvironment/clnkins3a001s01qw9k3efaj5/draft",
    longitude: 118.875970,
    latitude: -2.324103, 
    zoom: 5, 
    minZoom: 4,
    maxZoom: 18,
    bearing: 0,
    pitch: 30,
    max_bounds: [
      [119-50, -2-25],   // Southwest (lng/lat)
      [119+50, -2+25]     // Northeast (lng/lat)
    ],
  },
  UI: {
    height: 75,
    before_layer: 'waterway-label',
    large_screen: 900,
    load_delay_base: 0,
    load_delay_random: 0,
  },

  /* suitability: [
    { name: 'Spatial constraints', color: '#aaaaaa', hidden: true },
    { name: 'Not suitable', color: '#dc1010' },
    { name: 'Moderately suitable', color: '#ff6d01' },
    { name: 'Suitable', color: '#128800' },
    { name: 'Highly suitable', color: '#0cf600' },
  ], */  

  datasets: [
    ...Object.entries(MANGROVES).map(([year, uuid], i, arr) => ({
      key: `mangroves${year}`,
      ids: [ `mangroves${year}` ],
      title: `Mangroves ${year}`,
      //description: `Mangroves in ${year}`,
      group: 'mangroves',
      active: i === arr.length - 1,
      renderer: (p: ILoaderProps) => <Mangroves {...p} id={`mangroves${year}`} uuid={uuid}/>
    })),
    ...Object.entries(PONDS).map(([year, uuid], i, arr) => ({
      key: `ponds${year}`,
      ids: [ `ponds${year}` ],
      title: `Pond aquaculture ${year}`,
      //description: `Pond aquaculture in ${year}`,
      group: 'ponds',
      active: i === arr.length - 1,
      renderer: (p: ILoaderProps) => <Ponds {...p} id={`ponds${year}`} uuid={uuid}/>
    }))    
   ],
  datagroups: [
    {
      key: 'mangroves',
      title: 'Mangroves',
      description: 'Mangrove Coverage and Carbon Stocks Across Java, Sulawesi, Sumatra, and Kalimantan, Indonesia',
      exclusive: true,      
    },
    {
      key: 'ponds',
      title: 'Pond aquaculture',
      description: 'Pond Aquaculture Coverage and Carbon Stocks Across Java, Sulawesi, Sumatra, and Kalimantan, Indonesia',
      exclusive: true,
    }
  ],
  dictionary: [    
    {
      key: 'suitability',
      text: 'Suitability',
      type: 'suitability'
    }, {
      key: 'adm1',
      text: 'Province'
    }, {
      key: 'adm2',
      text: 'Regency'
    },{
      key: 'area_ha',
      text: 'Area',
      unit: <>ha</>,
      type: 'number',
      decimals: 0
    }, {
      key: 'Cstocks',
      text: 'Carbon stocks',
      unit: <>tonnes</>,
      type: 'number',
      decimals: 0
    },        
    
  ]
}

export { Config }
